import { gql } from '@apollo/client';

export const ShippingSummaryFragment = gql`
    fragment ShippingSummaryFragment on Cart {
        shipping_addresses {
            selected_shipping_method {
                amount {
                    currency
                    value
                }
            }
        }
    }
`;

import React from 'react';
export default function Stub() { return null; }
